import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges
} from '@angular/core';
import { BaseComponent } from '../../../base.component';
import { Unit } from '../../../interfaces/unit.interface';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-unit-input-field',
    templateUrl: './unit-input-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule]
})
export class UnitInputFieldComponent extends BaseComponent implements OnChanges {
    @Input() placeholder: string;
    @Input() value: string;
    @Input() class = '';
    @Input() unit: string;
    @Input() id = '';
    @Input() autocomplete = 'off';
    @Input() type = 'search';

    @Output() changed = new EventEmitter<number>();

    control = new UntypedFormControl('');

    private inputValue: number;
    private inputLabel: string;

    ngOnChanges(changes: SimpleChanges) {
        if (changes.value) {
            this.inputValue = +this.value;
            this.inputLabel = Unit.formatToUnit(this.unit, this.value);
            this.control.setValue(this.inputLabel);
        }
    }

    onControlChange() {
        const value = this.control.value;
        if (this.control.value !== this.inputLabel) {
            this.inputValue = Unit.formatFromUnit(this.unit, value);
            this.inputLabel = Unit.formatValue(this.unit, value);
            this.control.setValue(this.inputLabel);
            this.changed.emit(this.inputValue);
        }
    }
}
